import stageSorter from ".//stageSorter";

const stageSorterMain = (array_to_sort, main_key) => {

                let output_array  = []
                let final_output_array = []

                let is_a_stage_name_array = array_to_sort[0][main_key].includes("Stage")

                if(is_a_stage_name_array) {
                                const unique_project_names = 	array_to_sort.reduce((ret_val, o)  =>  {
                                                let proj_name = o["name"].substring(0, o["name"].indexOf("- Stage ")-1)
                                                ret_val.indexOf(proj_name) == -1  && proj_name != "" ? ret_val.push(proj_name) : null
                                                return ret_val } ,[])		      
                                // console.log('unique_project_names : ' + unique_project_names)
                                // console.log('unique_project_names.length : ' + unique_project_names.length)
                                const unique_project_names_sorted = unique_project_names.sort()
                                console.log('unique_project_names_sorted : ' + unique_project_names_sorted)
                                unique_project_names.forEach( (e, i) => {
                                                output_array.push(stageSorter(array_to_sort.filter(a => ( a.name.includes(e + " -"))) , "name"))
                                })
                } else {
                                output_array.push(stageSorter(array_to_sort , "name"))
                }
                
                // console.log('output_array: ' + JSON.stringify(output_array))

                output_array.forEach( a => (
                                // console.log('a.length :'  + a.length + ' | final_output_array.length : ' + final_output_array.length),
                                final_output_array = final_output_array.concat( a)
                ))

                return final_output_array

}

export default stageSorterMain